import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import CVList from './CVList';
import { useAuth } from '../../AuthContext';
import WICVLoader from './../WICVLoader';
import './Dashboard.css';
import ErrorModal from './../ErrorModal';

const DashboardUser = () => {
  const { user, logout } = useAuth();
  const [profile, setProfile] = useState(user || {});
  const [cvs, setCvs] = useState([]);
  const [filteredCvs, setFilteredCvs] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (!user?.idUtilisateur) return;

    setLoading(true);
    setError(null);

    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const base = `${process.env.REACT_APP_API_BASE_URL}/api/user/${user.idUtilisateur}`;
      const [profileRes, cvsRes, notificationsRes] = await Promise.all([
        axios.get(base, { headers }),
        axios.get(`${base}/cvs`, { headers }),
        axios.get(`${base}/notifications`, { headers }),
      ]);

      setProfile(profileRes.data);
      setCvs(cvsRes.data);
      setFilteredCvs(cvsRes.data);
      setNotifications(notificationsRes.data);


    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const fileInputRefWikeys = useRef(null);
  const fileInputRefWissal = useRef(null);
  const fileInputRefWikeysAnglais = useRef(null);

  const handleGenerateCVWikeysClick = () => {
    fileInputRefWikeys.current.click();
  };

  const handleGenerateCVWissalClick = () => {
    fileInputRefWissal.current.click();
  };

  const handleGenerateCVWikeysAnglaisClick = () => {
    fileInputRefWikeysAnglais.current.click();
  };

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    setLoading(true);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('email', user.email); // Ajouter l'email

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/user/cvs/process`, // URL modifiée
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    await fetchData();
  } catch (err) {
    console.error('Erreur détaillée:', err);
    setError(err.response?.data?.message || err.message);
  } finally {
    setLoading(false);
  }
};

const handleFileChangeWissal = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    setLoading(true);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('email', user.email);

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/user/cvs/processWissal`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    await fetchData();
  } catch (err) {
    console.error('Erreur détaillée:', err);
    setError(err.response?.data?.message || err.message);
  } finally {
    setLoading(false);
  }
};

const handleFileChangeWikeysAnglais = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    setLoading(true);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('email', user.email); 

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/user/cvs/processWikeysAnglais`, 
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    await fetchData();
  } catch (err) {
    console.error('Erreur détaillée:', err);
    setError(err.response?.data?.message || err.message);
  } finally {
    setLoading(false);
  }
};

  const handleSearchChange = (keyword) => {
    const filtered = cvs.filter((cv) =>
      cv.nomFichier.toLowerCase().includes(keyword.toLowerCase())
    );
    setFilteredCvs(filtered);
  };

  useEffect(() => {
    fetchData();
  }, [user?.idUtilisateur]);

  if (loading) return <WICVLoader />;

  return (
    <div className="body-dushboard">
      <ErrorModal message={error} onClose={() => setError(null)} />

      <div className="dashboard-container">
        <Navbar
          user={profile}
          notifications={notifications}
          onLogout={logout}
          onSearchChange={handleSearchChange}
        />
        <main className="dashboard-main">
          <div className="dashboard-welcome">
            <h1 className="dashboard-welcome-title">
              Bienvenue, {profile.nom} {profile.prenom}
            </h1>
            <p className="dashboard-welcome-subtitle">
              Gérez et créez vos CVs professionnels en un clic
            </p>
          </div>
          <div className='dashboard-generate-btns'>
            <div className="dashboard-generate-btn-container">
              {/* Bouton Wikeys */}
              <button className="dashboard-generate-btn" onClick={handleGenerateCVWikeysClick}>
                Générer un nouveau CV Wikeys
              </button>
              <input
                type="file"
                ref={fileInputRefWikeys}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept=".pdf,.docx,.doc,.txt"
              />

              {/* Bouton Wissal */}
              <button className="dashboard-generate-btn" onClick={handleGenerateCVWissalClick}>
                Générer un nouveau CV Wissal
              </button>
              <input
                type="file"
                ref={fileInputRefWissal}
                onChange={handleFileChangeWissal}
                style={{ display: 'none' }}
                accept=".pdf,.docx,.doc,.txt"
              />

              {/* Nouveau bouton Wikeys Anglais */}
              <button className="dashboard-generate-btn" onClick={handleGenerateCVWikeysAnglaisClick}>
                Générer un nouveau CV Wikeys en anglais
              </button>
              <input
                type="file"
                ref={fileInputRefWikeysAnglais}
                onChange={handleFileChangeWikeysAnglais}
                style={{ display: 'none' }}
                accept=".pdf,.docx,.doc,.txt"
              />
            </div>
          </div>

          <CVList cvs={filteredCvs} refreshData={fetchData} />
        </main>
      </div>
    </div>
  );
};

export default DashboardUser;